export const ACADEMIA_URI = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdEkBoaxNY5D8JJqKmBwcpcJHVfhJmMvigYJIsvAN5FdKmCoQ/formResponse';

export const HMON_URI = 'https://docs.google.com/forms/u/2/d/e/1FAIpQLSeaG7ME235aq00cLAxyOVW4LnekoTI68chxGB7bkbuiduRYtQ/formResponse';

export const ENTRY_ACADEMIA = {
  servico: 'entry.72998713',
  date: 'entry.1309448216',
  unidade: 'entry.275485717',
  setor: 'entry.1073286246',
  materiais: 'entry.1986892611',
  os: 'entry.1053084165',
  day: 'entry.1309448216_day',
  month: 'entry.1309448216_month',
  year: 'entry.1309448216_year',
  day2: 'entry.72998713_day',
  month2: 'entry.72998713_month',
  year2: 'entry.72998713_year',
  enc: 'entry.848539894',
  serv: 'entry.1136451657',
};

export const ENTRY_HMON = {
  cliente: 'entry.2015943270',
  codigo: 'entry.800546336',
  material: 'entry.1557542801',
  setor: 'entry.1073286246',
  unid: 'entry.1373967913',
  qtd: 'entry.761035177',
  obs: 'entry.1804424579',
  status: 'entry.1915704119',
};
